// assets/variant-swatch.js

// Self-executing function to avoid global scope pollution
(function() {
  if (!window.toggleSwatchViewInitialized) {
    window.toggleSwatchViewInitialized = true;
    
    window.toggleSwatchView = function(button) {
      // Get the parent container
      const parentContainer = button.closest('.variant-picker__option-values');
      
      // Get the swatch container
      const swatchContainer = parentContainer.querySelector('.swatch-container');
      
      // Get current state
      const isExpanded = swatchContainer.classList.contains('show-all');
      
      // Toggle button active state
      button.classList.toggle('is-active');
      
      // Toggle show-all class
      if (!isExpanded) {
        swatchContainer.classList.add('show-all');

      } else {
        swatchContainer.classList.remove('show-all');
        const hiddenSwatches = swatchContainer.querySelectorAll('.color-swatch:nth-child(n+6)');
       }
    }
  }
})();